import React from 'react';
// Import Global Components
import InfoTooltip from '../../../../components/InfoTooltip';

export function FrequencyTooltip() {
  return <InfoTooltip
    position="top"
    content={
      <>
        <p>
          <b>Daily:</b> Every Day at 6PM UTC
        </p>
        <p>
          <b>Weekly:</b> Every Sunday at 6PM UTC
        </p>
        <p>
          <b>Monthly:</b> Every First of the Month at 6PM UTC
        </p>
      </>
    }
  />;
}

export function TimeRangeTooltip() {
  return <InfoTooltip
    position="top"
    content={
      <>
        <p>
          You may select a time range up to <b>93 days</b> in the past from
          today's date.
        </p>
        <p>
          You may not be able to select a time in the past if it is before the
          selected program's <b>start date</b>
        </p>
      </>
    }
  />;
}

export function ReportingMethodTooltip() {
  return <InfoTooltip
    position="top"
    content={
      <>
        <p>
          <b>Email:</b> Receive reports via email
        </p>
        <p>
          <b>SFTP:</b> Receive reports via SFTP
        </p>
        <p>
          <b>Email and SFTP:</b> Receive reports via both Email and SFTP
        </p>
      </>
    }
  />;
}

export function EmailTooltip() {
  return <InfoTooltip
    position="top"
    content={
      <p>
          You <b>must</b> provide an email address to receive reports via email
      </p>
    }
  />;
}

export function CartaFrequencyTooltip() {
  return <InfoTooltip
    position="top"
    content={
      <>
        <p>
          <b>Daily:</b> Every Day by 6PM UTC 
        </p>
        <p>
          <b>Weekly:</b> Every Monday by 6PM UTC
        </p>
        <p>
          <b>Monthly:</b> Every First of the Month by 6PM UTC
        </p>
      </>
    }
  />;
}